(function () {
  'use strict';

  angular
    .module('itecAdministracio.rols.main.submain.permisos')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('rols.main.submain.permisos', {
        url: '/permisos',

      views: {
          'headerSubmenu@': {
            templateUrl: 'shared/header-submenu/headerSubmenu.tpl.html',
            controller: 'HeaderSubmenuCtrl',
            controllerAs: 'vm',
            resolve: {
              optionsHeaderSubmenuData: function(permisosRolsHeaderSubmenuLinksValue){
                return permisosRolsHeaderSubmenuLinksValue;
              }
            }
          },
          'content@rols.main.submain': {
            templateUrl: 'rols/main/permisos/permisos.tpl.html',
            controller: 'RolsMainPermisosCtrl',
            controllerAs: 'ctrl'
          }
        },
        breadcrumb: 'DEFAULT_ROLS_PERMISOS'
      });
  }
}());
